//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export enum UniversalUploadBroadcastCalls {
  ContentFailed = 'universal-upload:content-failed',
  ContentUploaded = 'universal-upload:content-uploaded',
  QueuedUpload = 'universal-upload:add-queued-upload'
}
